import { OnlineStorage } from "@tblabs/storage";
import { Div, Span, Text } from "@tblabs/truffle";
import { UserSection } from "./UserSection";
import { Router } from "../Services/Router";
import { AppState } from "../Services/AppState";


export class PageHeader extends Div
{
    constructor(_storage: OnlineStorage, _router: Router, _appState: AppState)
    {
        super("header");

        this.Append(
            new Div("header-left").CursorPointer()
                .OnClick(() => _router.GoToDatabasePage(_storage.DatabaseDir))
                .Append(
                    new Span("Storage Admin panel").Color("#fdfdfd").FontSize(18),
                    new Text(_appState.Subtitle).Color("#e2e2e2").FontSize(12),
                ),
            new Div("header-right").Append(
                new UserSection(_storage, _router),
            )
        );
    }
}
